import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Star } from 'lucide-react';
export function ExpertComparison() {
  const comparisons = [{
    situation: 'Querés una vista panorámica de Londres',
    sin: 'Pagás £32 el London Eye',
    con: 'Sky Garden gratis con reserva anticipada'
  }, {
    situation: 'Querés hacer el city-tour',
    sin: 'Pagás £35 el bus turístico',
    con: 'Bus 11 por £1.75 desde la primera fila'
  }, {
    situation: 'Querés comer bien sin gastar de más',
    sin: 'Restaurante turístico £30+',
    con: 'Set Menu o Pre-Theatre por £15-£20'
  }, {
    situation: 'Te sobra tiempo y querés comer barato',
    sin: 'Improvisás y pagás de más',
    con: 'Too Good To Go: bolsa de £15 por £4'
  }, {
    situation: 'Querés cruzar el Támesis',
    sin: 'Tour en barco turístico £20',
    con: 'Thames Clipper con Oyster £3'
  }, {
    situation: 'Buscás algo fuera del circuito',
    sin: 'Turismo genérico',
    con: 'Barrios secretos y pubs históricos'
  }, {
    situation: 'Querés ver música en vivo',
    sin: 'Shows caros en el West End',
    con: 'Jazz en vivo desde £0 en Soho'
  }];
  const inclusions = ['Itinerario de 5 días de bajo costo completo', 'Las 5 mejores vistas gratuitas de Londres', 'Los mercados ocultos donde comen los locales', 'El truco del Daily Cap en el Tube', 'Apps que solo usan los londinenses', 'Shopping en Charity Shops y TK Maxx', 'Pubs históricos con historia real', 'Barrios secretos fuera del circuito turístico'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900 border-y border-slate-800" data-id="element-64">
      <div className="max-w-5xl mx-auto" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/20 text-amber-400 mb-6" data-id="element-67">
            <Star className="w-8 h-8" data-id="element-68" />
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-69">
            <span className="text-2xl" data-id="element-70">🕊️</span> ¿QUÉ AGREGA LONDRES LEVEL
            EXPERT?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="overflow-x-auto mb-16" data-id="element-71">
          <table className="w-full text-left border-collapse min-w-[800px]" data-id="element-72">
            <thead data-id="element-73">
              <tr data-id="element-74">
                <th className="p-4 border-b border-slate-700 text-slate-400 font-semibold w-1/3" data-id="element-75">
                  Situación en el viaje
                </th>
                <th className="p-4 border-b border-slate-700 text-red-400 font-bold bg-red-950/20 w-1/3" data-id="element-76">
                  <div className="flex items-center gap-2" data-id="element-77">
                    <X className="w-5 h-5" data-id="element-78" /> Sin Expert
                  </div>
                </th>
                <th className="p-4 border-b border-slate-700 text-amber-400 font-bold bg-amber-950/20 w-1/3" data-id="element-79">
                  <div className="flex items-center gap-2" data-id="element-80">
                    <Check className="w-5 h-5" data-id="element-81" /> Con Expert
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-82">
              {comparisons.map((row, i) => <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-800/30 transition-colors" data-id="element-83">
                  <td className="p-4 text-slate-300 font-medium" data-id="element-84">
                    {row.situation}
                  </td>
                  <td className="p-4 text-slate-400 bg-red-950/10" data-id="element-85">
                    {row.sin}
                  </td>
                  <td className="p-4 text-amber-100 bg-amber-950/10 font-medium" data-id="element-86">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass-panel p-8 rounded-2xl border-amber-500/30 bg-gradient-to-br from-slate-900 to-slate-800" data-id="element-87">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-88">
            <Check className="w-6 h-6 text-amber-400" data-id="element-89" /> El Expert incluye:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-90">
            {inclusions.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-91">
                <Star className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-92" />
                <span className="text-slate-300 font-medium" data-id="element-93">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}